import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { transformErrorResponse } from 'helpers/errors';
import SearchUsersForm from 'components/SearchUsersForm';
import FormError from 'components/FormError';
import CheckboxInput from '../../components/CheckboxInput';
import { USER_ACL_GROUPS } from '../../constants';
import Spinner from 'components/Spinner';

class UpdateCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      success: false,
      redirect: false,
      selected: undefined,
      shouldUpdateSubs: true,
      loading: false,
      wasSearched: false,
    };
  }

  handleCheckbox = () => {
    this.setState((state) => ({ shouldUpdateSubs: !state.shouldUpdateSubs }));
  };

  selectUser = (user) => {
    if (user) {
      this.setState({
        selected: user,
      });
    }
  };

  searchUsers = (values) => {
    const { searchUsers } = this.props;
    this.setState({
      wasSearched: true,
      loading: true,
    });

    return searchUsers(1, {
      acl_group_name: USER_ACL_GROUPS.filter((group) => group !== 'USER').join(
        ',',
      ),
      ...values,
    }).then((res) => {
      this.setState({ loading: false });
      return res;
    });
  };

  updateCreator = () => {
    const { user, updateUserCreator } = this.props;
    const { selected, shouldUpdateSubs } = this.state;

    updateUserCreator({
      id: user.id,
      created_by: selected.id,
      update_subscriptions: shouldUpdateSubs,
    })
      .then((res) => {
        this.setState({ success: true }, () =>
          setTimeout(() => this.setState({ redirect: true }), 3000),
        );
      })
      .catch((err) => {
        this.setState({ error: transformErrorResponse(err.errors) });
      });
  };

  render() {
    const { user, users, redirectUrl } = this.props;
    const {
      error,
      success,
      selected,
      shouldUpdateSubs,
      redirect,
      wasSearched,
      loading,
    } = this.state;

    if (redirect) {
      return <Redirect to={redirectUrl(user.id)} />;
    }

    return (
      <div>
        <h1>Update Creator</h1>
        <div className="mar-b">
          <div>
            <strong>User ID</strong>: {user && user.id}
          </div>
          <div>
            <strong>First Name</strong>: {user && user.first_name}
          </div>
          <div>
            <strong>Last Name</strong>: {user && user.last_name}
          </div>
          <div>
            <strong>Email</strong>: {user && user.email}
          </div>
        </div>
        <SearchUsersForm
          onSubmit={this.searchUsers}
          fields={['email', 'first_name', 'last_name']}
        />
        {wasSearched && users && users.length > 0 && (
          <table className="table table-striped">
            <thead>
              <tr>
                <th>User ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Role</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr className="transfer-sub-users" key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user.acl_group_name}</td>
                  <td>
                    <button
                      className={
                        selected && selected.id === user.id
                          ? 'btn btn-primary'
                          : 'btn btn-default'
                      }
                      onClick={() => this.selectUser(user)}
                    >
                      {selected && selected.id === user.id
                        ? 'Selected'
                        : 'Select'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div>
          <CheckboxInput
            label="Update subscriptions"
            input={{ onChange: this.handleCheckbox, checked: shouldUpdateSubs }}
          />
        </div>
        {selected && selected.id ? (
          <div>
            <button
              className="btn btn-primary"
              disabled={!selected}
              onClick={this.updateCreator}
            >
              Update Creator
            </button>
            <span className="mar-l mar-t">
              Selected User: {selected.first_name} {selected.last_name} -{' '}
              {selected.email}
            </span>
            {success && (
              <div className="text-success">Creator changed successfully</div>
            )}
          </div>
        ) : null}
        <Spinner showLoader={loading} />
        {error && <FormError error={error} />}
        {!loading && wasSearched && users && users.length === 0 && (
          <div className="mar-t">No results</div>
        )}
      </div>
    );
  }
}

export default UpdateCreator;
